export const GAME_MODES = {
  TIME_CHALLENGE: 'timeChallenge',
  ENDLESS: 'endless',
  PRECISION: 'precision'
};

export const CHARACTERS = [
  { id: 'pony', icon: 'FaHorse', name: '小馬', points: 10, color: '#FF69B4' },
  { id: 'unicorn', icon: 'FaHatWizard', name: '獨角獸', points: 10, color: '#9370DB' },
  { id: 'cat', icon: 'FaCat', name: '貓咪', points: 10, color: '#FFA500' },
  { id: 'dog', icon: 'FaDog', name: '狗狗', points: 10, color: '#8B4513' },
  { id: 'rabbit', icon: 'FaCarrot', name: '兔子', points: 10, color: '#FFC0CB' },
  { id: 'duck', icon: 'FaKiwiBird', name: '小鴨', points: 10, color: '#FFD700' },
  { id: 'fish', icon: 'FaFish', name: '魚兒', points: 10, color: '#00BFFF' },
  { id: 'dragon', icon: 'FaDragon', name: '龍', points: 10, color: '#32CD32' },
  { id: 'bear', icon: 'FaPaw', name: '熊', points: 10, color: '#8B4513' },
  { id: 'fox', icon: 'FaFontAwesomeFlag', name: '狐狸', points: 10, color: '#FF6347' },
  { id: 'star', icon: 'FaStar', name: '星星', points: 10, color: '#FFD700' },
  { id: 'moon', icon: 'FaMoon', name: '月亮', points: 10, color: '#B0C4DE' },
  { id: 'planet', icon: 'FaGlobeAmericas', name: '星球', points: 10, color: '#2E8B57' }
];

export const SPECIAL_BUBBLES = {
  gold: {
    type: 'gold',
    icon: 'FaCoins',
    name: '金色泡泡',
    points: 50,
    health: 3,
    color: '#FFD700',
    effect: 'score'
  },
  time: {
    type: 'time',
    icon: 'FaHourglassHalf',
    name: '時間泡泡',
    points: 20,
    health: 3,
    color: '#00FFFF',
    effect: 'time'
  },
  bomb: {
    type: 'bomb',
    icon: 'FaBomb',
    name: '爆炸泡泡',
    points: 30,
    health: 3,
    color: '#FF0000',
    effect: 'explode'
  },
  combo: {
    type: 'combo',
    icon: 'FaBolt',
    name: '連擊泡泡',
    points: 40,
    health: 3,
    color: '#9400D3',
    effect: 'combo'
  }
};

export const ACHIEVEMENTS = [
  // 🎯 基礎點擊成就 (4個)
  {
    id: 'beginner',
    name: '泡泡新手',
    description: '點擊10個泡泡',
    icon: 'FaHandPointer',
    category: 'basic',
    condition: (stats) => stats.totalPopped >= 10
  },
  {
    id: 'intermediate',
    name: '泡泡愛好者',
    description: '點擊50個泡泡',
    icon: 'FaHandPaper',
    category: 'basic',
    condition: (stats) => stats.totalPopped >= 50
  },
  {
    id: 'advanced',
    name: '泡泡專家',
    description: '點擊150個泡泡',
    icon: 'FaHandRock',
    category: 'basic',
    condition: (stats) => stats.totalPopped >= 150
  },
  {
    id: 'master',
    name: '泡泡大師',
    description: '點擊300個泡泡',
    icon: 'FaCrown',
    category: 'basic',
    condition: (stats) => stats.totalPopped >= 300
  },

  // ⚡ 連擊成就 (5個)
  {
    id: 'combo3',
    name: '連擊起步',
    description: '達成3連擊',
    icon: 'FaBolt',
    category: 'combo',
    condition: (stats) => stats.maxCombo >= 3
  },
  {
    id: 'combo5',
    name: '連擊好手',
    description: '達成5連擊',
    icon: 'FaBolt',
    category: 'combo',
    condition: (stats) => stats.maxCombo >= 5
  },
  {
    id: 'combo10',
    name: '連擊達人',
    description: '達成10連擊',
    icon: 'FaBolt',
    category: 'combo',
    condition: (stats) => stats.maxCombo >= 10
  },
  {
    id: 'combo15',
    name: '連擊高手',
    description: '達成15連擊',
    icon: 'FaBolt',
    category: 'combo',
    condition: (stats) => stats.maxCombo >= 15
  },
  {
    id: 'combo20',
    name: '連擊傳說',
    description: '達成20連擊',
    icon: 'FaBolt',
    category: 'combo',
    condition: (stats) => stats.maxCombo >= 20
  },

  // 🚀 等級成就 (4個)
  {
    id: 'level2',
    name: '衝刺者',
    description: '達到等級2',
    icon: 'FaArrowUp',
    category: 'level',
    condition: (stats) => stats.level >= 2
  },
  {
    id: 'level3',
    name: '疾風玩家',
    description: '達到等級3',
    icon: 'FaWind',
    category: 'level',
    condition: (stats) => stats.level >= 3
  },
  {
    id: 'level4',
    name: '閃電戰士',
    description: '達到等級4',
    icon: 'FaBolt',
    category: 'level',
    condition: (stats) => stats.level >= 4
  },
  {
    id: 'level5',
    name: '光速傳說',
    description: '達到等級5(最高等級)',
    icon: 'FaRocket',
    category: 'level',
    condition: (stats) => stats.level >= 5
  },

  // 💎 特殊泡泡成就 (4個)
  {
    id: 'gold_first',
    name: '尋寶者',
    description: '點擊1個金色泡泡',
    icon: 'FaCoins',
    category: 'special',
    condition: (stats) => (stats.specialBubbles?.gold || 0) >= 1
  },
  {
    id: 'time_first',
    name: '時間管理',
    description: '點擊1個時間泡泡',
    icon: 'FaHourglassHalf',
    category: 'special',
    condition: (stats) => (stats.specialBubbles?.time || 0) >= 1
  },
  {
    id: 'bomb_first',
    name: '爆破專家',
    description: '點擊1個爆炸泡泡',
    icon: 'FaBomb',
    category: 'special',
    condition: (stats) => (stats.specialBubbles?.bomb || 0) >= 1
  },
  {
    id: 'combo_bubble',
    name: '連擊獵人',
    description: '點擊1個連擊泡泡',
    icon: 'FaBolt',
    category: 'special',
    condition: (stats) => (stats.specialBubbles?.combo || 0) >= 1
  },

  // 🏆 分數成就 (5個)
  {
    id: 'score100',
    name: '初級得分手',
    description: '單局得分達到100分',
    icon: 'FaStar',
    category: 'score',
    condition: (stats) => stats.highScore >= 100
  },
  {
    id: 'score300',
    name: '中級得分手',
    description: '單局得分達到300分',
    icon: 'FaStar',
    category: 'score',
    condition: (stats) => stats.highScore >= 300
  },
  {
    id: 'score500',
    name: '高級得分手',
    description: '單局得分達到500分',
    icon: 'FaStar',
    category: 'score',
    condition: (stats) => stats.highScore >= 500
  },
  {
    id: 'score1000',
    name: '得分大師',
    description: '單局得分達到1000分',
    icon: 'FaTrophy',
    category: 'score',
    condition: (stats) => stats.highScore >= 1000
  },
  {
    id: 'score2000',
    name: '得分傳說',
    description: '單局得分達到2000分',
    icon: 'FaTrophy',
    category: 'score',
    condition: (stats) => stats.highScore >= 2000
  },

  // 🎮 特殊挑戰成就 (3個)
  {
    id: 'speed_demon',
    name: '速度惡魔',
    description: '10秒內點擊12個泡泡',
    icon: 'FaTachometerAlt',
    category: 'challenge',
    condition: (stats) => (stats.speedCount || 0) >= 12
  },
  {
    id: 'special_hunter',
    name: '特殊獵人',
    description: '點擊5個特殊泡泡',
    icon: 'FaGem',
    category: 'challenge',
    condition: (stats) => {
      const total = (stats.specialBubbles?.gold || 0) +
                   (stats.specialBubbles?.time || 0) +
                   (stats.specialBubbles?.bomb || 0) +
                   (stats.specialBubbles?.combo || 0);
      return total >= 5;
    }
  },
  {
    id: 'perfect_level5',
    name: '完美極速',
    description: '在等級5維持10連擊',
    icon: 'FaAward',
    category: 'challenge',
    condition: (stats) => stats.level >= 5 && stats.maxCombo >= 10
  }
];

// 成就分類資訊
export const ACHIEVEMENT_CATEGORIES = {
  basic: {
    name: '基礎成就',
    icon: 'FaHandPointer',
    color: 'blue',
    description: '通過點擊泡泡解鎖'
  },
  combo: {
    name: '連擊成就',
    icon: 'FaBolt',
    color: 'purple',
    description: '通過連續點擊解鎖'
  },
  level: {
    name: '等級成就',
    icon: 'FaRocket',
    color: 'green',
    description: '通過提升等級解鎖'
  },
  special: {
    name: '特殊泡泡',
    icon: 'FaGem',
    color: 'yellow',
    description: '點擊特殊泡泡解鎖'
  },
  score: {
    name: '分數成就',
    icon: 'FaTrophy',
    color: 'orange',
    description: '通過高分解鎖'
  },
  challenge: {
    name: '挑戰成就',
    icon: 'FaAward',
    color: 'red',
    description: '完成特殊挑戰解鎖'
  }
};